import React, { useEffect } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useService } from "@xstate/react";
import { service } from "@uidaholib/shared/machines/map/map.machine";
import { Sidebar } from "./sidebar";
import { WebMapView } from "./web-map-view";
import { DownloadModal } from "./download-modal";
import { featureStore } from "@uidaholib/shared/models/features/features";
import { configStore } from "@uidaholib/shared/models/config/config";
import { getConfig } from "@uidaholib/shared/constants/config";
import { observer } from "mobx-react-lite";

export const Root = observer(({ mapId, title, appName }) => {
  const [state, send] = useService(service);
  let config = getConfig(appName);

  useEffect(() => {
    configStore.setConfig(appName);
    send({ type: "LOAD", container: mapId, config });
    featureStore.loadFeatures(config);
  }, []);

  return (
    <Flex flexDir="column" minH={0} h="100%" w="100%" overflow="hidden">
      <Sidebar title={config && config.appTitle} />
      <WebMapView mapId={mapId} appName={appName} />
      <DownloadModal appName={appName} />
    </Flex>
  );
});
